import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const MinistryCard = ({ 
  title, 
  description, 
  image, 
  link = "/ministries",
  buttonText = "Learn More"
}) => {
  return (
    <div 
      className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border-t-4 border-secondary overflow-hidden group"
      data-testid={`ministry-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {/* Image */}
      <div className="relative h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="font-heading text-xl font-semibold text-primary-900 mb-3 group-hover:text-secondary transition-colors">
          {title}
        </h3>
        <p className="text-slate-600 text-sm leading-relaxed mb-4 line-clamp-3">
          {description}
        </p>
        <Link
          to={link}
          className="inline-flex items-center gap-2 text-secondary font-semibold text-sm hover:gap-3 transition-all"
          data-testid={`ministry-card-btn-${title.toLowerCase().replace(/\s+/g, '-')}`}
        >
          {buttonText}
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};
